import { AccountOffOutlineIcon } from './AccountOffOutlineIcon';

/**
 * author: Austin Andrews
 * id 231E3EA7-A7EC-41A0-A594-032040488448
 * name account-off-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-off-outline.svg
 * tags
 * - Account / User 
 */
export const UserOffOutlineIcon = AccountOffOutlineIcon;
export default UserOffOutlineIcon